import { X, Languages } from "lucide-react";

/**
 * Overlays translated text chips at AI-returned normalized bounding boxes
 * on top of the frozen captured frame.
 */
export default function TranslationOverlay({ scan, onClose }) {
  if (!scan) return null;
  const boxes = Array.isArray(scan.boxes) ? scan.boxes : [];

  return (
    <div className="fixed inset-0 z-40" data-testid="translation-overlay">
      <div className="absolute inset-0 bg-black/40" />
      {scan.thumbnail && (
        <img
          src={scan.thumbnail}
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-80"
        />
      )}

      {/* Scan sweep flash */}
      <div className="absolute inset-x-0 top-0 h-1 bg-cyan-400 shadow-[0_0_18px_rgba(0,229,255,0.9)]" />

      {/* Boxes */}
      {boxes.map((b, i) => {
        const left = `${(b.x * 100).toFixed(2)}%`;
        const top = `${(b.y * 100).toFixed(2)}%`;
        const width = `${(Math.max(0.06, b.w) * 100).toFixed(2)}%`;
        return (
          <div
            key={i}
            data-testid={`translation-box-${i}`}
            style={{ left, top, width }}
            className="absolute jx-fade-up"
          >
            <div className="jx-glass border border-cyan-400/60 rounded-lg px-2 py-1 shadow-[0_0_18px_rgba(0,229,255,0.35)]">
              <p className="text-[10px] font-mono-data uppercase tracking-widest text-cyan-300 truncate">
                {b.source}
              </p>
              <p className="text-xs font-heading font-semibold text-white leading-tight">
                {b.translation}
              </p>
            </div>
          </div>
        );
      })}

      {boxes.length === 0 && (
        <div className="absolute inset-x-6 top-1/3 jx-glass rounded-2xl p-4 text-center">
          <Languages className="mx-auto text-cyan-300" size={22} />
          <p className="mt-2 text-sm text-slate-200">{scan.summary || "No readable text detected."}</p>
        </div>
      )}

      {/* Top bar */}
      <div className="absolute top-3 left-1/2 -translate-x-1/2 max-w-md w-[92%] flex items-center gap-2 z-10">
        <div className="jx-glass rounded-full px-3 py-1.5 flex items-center gap-1.5">
          <Languages size={14} className="text-cyan-300" />
          <span className="text-[11px] font-mono-data uppercase tracking-widest text-cyan-200">
            Live Translation · {boxes.length} segment{boxes.length === 1 ? "" : "s"}
          </span>
        </div>
        <button
          data-testid="translation-overlay-close"
          onClick={onClose}
          className="ml-auto jx-glass w-10 h-10 rounded-full flex items-center justify-center active:scale-95"
        >
          <X size={18} />
        </button>
      </div>

      {/* Footer watermark */}
      <div className="absolute bottom-28 left-0 right-0 text-center pointer-events-none">
        <p className="text-[10px] font-mono-data uppercase tracking-widest text-cyan-300/80">
          Jixxeo AI · Translator Vision
        </p>
      </div>
    </div>
  );
}
